import { Fragment } from 'react'
import {
    ImageContainer,
    PlateImageHeading,
    PlateImageTitle,
    PlateImageSize,
    PlateImageContainer,
    PlateImage,
    MobileImageContainer,
    MobilePlateImageHeading,
    MobilePlateImageContainer,
    InfoBannerPlateImage,
    ImageContainerColumn
} from './PlateDesignImagesContainer.styles'
import { PlateImageModel, CurrentPlateDesign, VehicleTypesSetting, VehicleType } from "~/dataModels/ProductModels";
import { buildPlateImageUrl, getFrontPlateWidth, getBackPlateWidth } from '@utils/Helpers';
import { Grid } from 'semantic-ui-react';
import { H2 } from '@styles/Global.styles';

interface PlateimageComponentProps {
    apiUrl: string
    plateImageModel: PlateImageModel
    darkTheme: boolean
}

export const PlateDesignImagesBannerStrip = (props: PlateimageComponentProps) => {
    const { formattedCombination, vehicleType, frontPlate, backPlate } = props.plateImageModel;
    const frontPlateWidth = getFrontPlateWidth(frontPlate.plateSize.width, backPlate.plateSize.width);
    const backPlateWidth = getBackPlateWidth(frontPlate.plateSize.width, backPlate.plateSize.width);
    const frontPlateUrl = buildPlateImageUrl(props.apiUrl, frontPlate, formattedCombination, 750);
    const backPlateUrl = buildPlateImageUrl(props.apiUrl, backPlate, formattedCombination, 750);
    return (
        <Grid>
            <ImageContainerColumn width={8}>
                <InfoBannerPlateImage src={frontPlateUrl} centered width={frontPlateWidth} alt={`${formattedCombination} plate image`} />
            </ImageContainerColumn>
            <ImageContainerColumn width={8}>
                {
                    vehicleType.id === VehicleTypesSetting.Car.id &&
                    <InfoBannerPlateImage src={backPlateUrl} centered width={backPlateWidth} alt={`${formattedCombination} plate image`} />
                }
            </ImageContainerColumn>
        </Grid>
    )
}


const PlateDesignImagesContainer = (props: PlateimageComponentProps) => {
    const { frontPlate, backPlate, formattedCombination, vehicleType, title } = props.plateImageModel;
    const frontPlateWidth = getFrontPlateWidth(frontPlate.plateSize.width, backPlate.plateSize.width);
    const backPlateWidth = getBackPlateWidth(frontPlate.plateSize.width, backPlate.plateSize.width);
    const frontPlateUrl = buildPlateImageUrl(props.apiUrl, frontPlate, formattedCombination, 750);
    const backPlateUrl = buildPlateImageUrl(props.apiUrl, backPlate, formattedCombination, 750);
    return (
        <ImageContainer darkTheme={props.darkTheme}>
            <Grid>
                {
                    title !== undefined &&
                    <Grid.Row>
                        <Grid.Column>
                            <H2>{title}</H2>
                        </Grid.Column>
                    </Grid.Row>
                }
                <Grid.Row>
                    {
                        vehicleType.id === VehicleTypesSetting.Car.id &&
                        <Grid.Column mobile={8} tablet={8} computer={16}>
                            <PlateImageHeading>
                                <PlateImageTitle>Front Plate</PlateImageTitle>
                                <PlateImageSize>{frontPlate.plateSize.width}x{frontPlate.plateSize.height}mm</PlateImageSize>
                            </PlateImageHeading>
                            <PlateImageContainer>
                                <PlateImage src={frontPlateUrl} centered width={frontPlateWidth} alt={`${formattedCombination} plate image`} />
                            </PlateImageContainer>
                        </Grid.Column>
                    }
                    <Grid.Column mobile={8} tablet={8} computer={16}>
                        <PlateImageHeading>
                            <PlateImageTitle>Back Plate</PlateImageTitle>
                            <PlateImageSize>{backPlate.plateSize.width}x{backPlate.plateSize.height}mm</PlateImageSize>
                        </PlateImageHeading>
                        <PlateImageContainer>
                            <PlateImage src={backPlateUrl} centered width={backPlateWidth} alt={`${formattedCombination} plate image`} />
                        </PlateImageContainer>
                    </Grid.Column>


                </Grid.Row>

            </Grid>
        </ImageContainer>
    )
}

interface MobilePlateImageModel {
    apiUrl: string
    formattedCombination: string
    vehicleType: VehicleType
    currentPlateDesign: CurrentPlateDesign,
    darkTheme: boolean
}

export default PlateDesignImagesContainer

export const MobilePlateDesignImagesContainer = ({ apiUrl, formattedCombination, vehicleType, currentPlateDesign, darkTheme }: MobilePlateImageModel) => {
    const frontPlateWidth = getFrontPlateWidth(currentPlateDesign.frontPlate.plateSize.width, currentPlateDesign.backPlate.plateSize.width);
    const backPlateWidth = getBackPlateWidth(currentPlateDesign.frontPlate.plateSize.width, currentPlateDesign.backPlate.plateSize.width);
    const frontPlateUrl = buildPlateImageUrl(apiUrl, currentPlateDesign.frontPlate, formattedCombination, 750);
    const backPlateUrl = buildPlateImageUrl(apiUrl, currentPlateDesign.backPlate, formattedCombination, 750);
    return (
        <MobileImageContainer>
            {vehicleType.id === VehicleTypesSetting.Car.id &&
            <Fragment>
                <MobilePlateImageHeading textColor={darkTheme ? 'white' : 'black'}>
                    {currentPlateDesign.frontPlate.plateDesignCode == currentPlateDesign.backPlate.plateDesignCode ? <PlateImageTitle>Front & Back Plate</PlateImageTitle> : <PlateImageTitle>Front Plate</PlateImageTitle>}
                    <PlateImageSize>{currentPlateDesign.frontPlate.plateSize.width}x{currentPlateDesign.frontPlate.plateSize.height}mm</PlateImageSize>
                </MobilePlateImageHeading>
                <MobilePlateImageContainer>
                    <PlateImage src={frontPlateUrl} centered width={frontPlateWidth} alt={`${formattedCombination} plate image`} />
                </MobilePlateImageContainer>
            </Fragment>}
            {(currentPlateDesign.frontPlate.plateDesignCode != currentPlateDesign.backPlate.plateDesignCode || vehicleType.id !== VehicleTypesSetting.Car.id) ?
            <Fragment>
                <MobilePlateImageHeading textColor={darkTheme ? 'white' : 'black'}>
                    <PlateImageTitle>Back Plate</PlateImageTitle>
                    <PlateImageSize>{currentPlateDesign.backPlate.plateSize.width}x{currentPlateDesign.backPlate.plateSize.height}mm</PlateImageSize>
                </MobilePlateImageHeading>
                <MobilePlateImageContainer>
                    <PlateImage src={backPlateUrl} centered width={backPlateWidth} alt={`${formattedCombination} plate image`} />
                </MobilePlateImageContainer>
            </Fragment> : <></>}

        </MobileImageContainer>
    )
}

